import { apiClient } from '../../../client'
import { useGenericRequestHandler } from '../../../handlers'

function getEndpoint(moteId: string, v1: boolean = false) {
  let url = `m/delete/${moteId}`
  if (v1) {
    url = 'v1/' + url
  }
  return url
}

export function useMoteDeleteMutation(moteId: string, v1: boolean = false) {
  return useGenericRequestHandler({
    route: getEndpoint(moteId, v1),
    method: 'POST'
  })
}

export function moteDeleteRaw(moteId: string) {
  return apiClient.post(getEndpoint(moteId)).then(response => response.json())
}
